import { Link } from 'react-router';

import OverviewTable from '../../components/OverviewTable/OverviewTable';

import { useUserData } from '@/redux/selectors';
import type { Row } from '@/types/tableTypes';

const AccountOverview = (): React.ReactElement => {
  const { email, beautifiedRole, organization } = useUserData();

  const rows: Row[] = [
    {
      title: { id: 'organization' },
      value: organization?.enterpriseName,
      component: organization?._id ? (
        <Link to={`/governance/organizations/${organization._id}`}>
          {organization.enterpriseName}
        </Link>
      ) : undefined,
    },
    { title: { id: 'role' }, value: beautifiedRole },
  ];

  return (
    <OverviewTable
      header={email}
      rows={rows}
    />
  );
};

export default AccountOverview;
